import { IBasicInfoViewModel } from "pages/MainPage/components/BasicInfoSection/viewModels";
import IProfileViewBasicInfo from "models/ProfileView/ProfileViewBasicInfo";
import { VisibilitySettingsSuppressed } from "pages/Profile/helpers/basic-info-converter/types";
import BasicInfo from "models/BasicInfo/BasicInfo";

export function applyVisibilitySettings({
  dataModel,
  basicInfoData,
  isPublicView,
  visibilitySettingSuppressed,
}: {
  dataModel: Partial<IBasicInfoViewModel>;
  basicInfoData: BasicInfo | IProfileViewBasicInfo | undefined;
  isPublicView: boolean;
  visibilitySettingSuppressed: VisibilitySettingsSuppressed;
}): Partial<IBasicInfoViewModel> {
  const basicVisibilitySettings = {
    gender: Boolean(!isPublicView || basicInfoData?.isVisibleGender),
    disability: Boolean(!isPublicView || basicInfoData?.isVisibleDisability),
    ethnicity: Boolean(
      !isPublicView || basicInfoData?.isVisibleHeritageAndEthnicity
    ),
    visasAndPermits: Boolean(
      !isPublicView || basicInfoData?.isVisibleVisasAndPermits
    ),
  };

  let result = { ...dataModel };

  if (!basicVisibilitySettings.gender && !visibilitySettingSuppressed.gender) {
    result = {
      ...result,
      genders: undefined,
    };
  }

  if (
    !basicVisibilitySettings.disability &&
    !visibilitySettingSuppressed.disability
  ) {
    result = { ...result, disabilities: undefined };
  }

  if (
    !basicVisibilitySettings.ethnicity &&
    !visibilitySettingSuppressed.ethnicity
  ) {
    result = { ...result, ethnicity: undefined };
  }

  if (!basicVisibilitySettings.visasAndPermits) {
    result = { ...result, visasAndPermits: undefined };
  }

  return result;
}
